import { updateTask, clearTask } from 'actions/transcribe/transcribeActions'
import { hideBlankProjectFromList } from 'actions/projectData/hideBlankProjectFromList'
import { createTranscribeTask, deleteTranscribeTask, getTranscribeTaskStatus, createProject, getProject } from '~/ServerAPI'
import { TASK_STATUS } from '~/enums'
import * as ActionTypes from '~/actions/ActionTypes'


const CHECK_STATUS_INTERVAL = 500
async function checkStatusLongPolling(dispatch, taskId) {
  try {
    const data = await getTranscribeTaskStatus(taskId)
    const { status, progress, error, result } = data
    if (error) {
      dispatch(updateTask({
        taskId,
        error,
        status,
      }))
      return
    }

    dispatch(updateTask({ taskId, status, progress, result }))
    if (status !== TASK_STATUS.COMPLETED && status !== TASK_STATUS.ABORTED) {
      setTimeout(checkStatusLongPolling, CHECK_STATUS_INTERVAL, dispatch, taskId)
    }
  } catch (error) {
    dispatch(updateTask({
      taskId,
      status: TASK_STATUS.ABORTED,
      error: {
        message: error.toString(),
      },
    }))
  }
}

export const requestCreateTask = (fileId,
  modelName) => async dispatch => {
  try {
    const response = await createTranscribeTask({ fileId, modelName })
    const taskId = response?.data?.id
    if (!taskId) {
      throw Error('taskId is empty')
    }
    await checkStatusLongPolling(dispatch, taskId)
  } catch (e) {
    const error = {
      message: e.data?.error || e.data?.message || e.toString(),
    }
    dispatch(updateTask({ status: TASK_STATUS.ABORTED, error }))
  }
}

export const requestDeleteTask = taskId => async dispatch => {
  try {
    await deleteTranscribeTask(taskId)
    dispatch(clearTask())
  } catch (e) {
    console.error(`requestDeleteTask ${e}`)
  }
}

export const requestCreateProjects = (projectName, fileId, textSegments) => async dispatch => {
  try {
    const projectParams = {
      name: `${projectName}`,
      fileId,
      textSegments,
    }
    const { id } = await createProject(projectParams)
    const project = await getProject(id)
    dispatch({
      type: ActionTypes.PROJECTS_CREATE,
      payload: { project },
    })
    await dispatch(hideBlankProjectFromList())
    return id
  } catch (e) {
    console.error(`requestCreateProject ${e}`)
    return null
  }
}
